import 'css-chunksrc/client/common/filterMenu/projects/styles.scss';export default {
  "header": "_header_1fr27_1",
  "icon": "_icon_1fr27_10",
  "title": "_title_1fr27_18",
  "list": "_list_1fr27_25"
};